import {useContext} from 'react';
import {ScopeContext} from '../policies/scopeContext';

export const useScopes = () => useContext(ScopeContext);
